import {CarouselSwiper, type SlideImage} from '@online-offer/shared';
import {Lightbox, useLightbox} from 'platform/lightbox';

import {CarouselButton} from '../CarouselButton/CarouselButton';

type PhotoCarouselProps = {
  /** Names the fullscreen view in the URL while it is open. */
  lightboxId: string;
  images: SlideImage[];
  isIllustrative: boolean | undefined;
};

/**
 * The photos of a vehicle. Real photos open in the fullscreen view; a catalogue photo stays inline,
 * as the fullscreen view cannot show its caption, even when the URL already names the view.
 */
export function PhotoCarousel(props: PhotoCarouselProps) {
  if (props.isIllustrative) {
    return (
      <CarouselSwiper
        CarouselButtonComponent={CarouselButton}
        images={props.images}
        onInspectImage={() => undefined}
      />
    );
  }
  return <CarouselWithFullscreen lightboxId={props.lightboxId} images={props.images} />;
}

function CarouselWithFullscreen(props: Pick<PhotoCarouselProps, 'lightboxId' | 'images'>) {
  const [lightboxControls, {onOpenBySlide}] = useLightbox(props.lightboxId);
  return (
    <>
      <CarouselSwiper
        CarouselButtonComponent={CarouselButton}
        images={props.images}
        onInspectImage={(slide) => onOpenBySlide(slide, props.images)}
      />
      <Lightbox data-testid={props.lightboxId} controls={lightboxControls} images={props.images} />
    </>
  );
}
